<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Templates de E-mail</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Templates</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">Código</th>
                    <th scope="col" class="border-0 text-left">Nome</th>
                    <th scope="col" class="border-0 text-left">Assunto</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(template, index) in templates" :key="index">
                    <td></td>
                    <td>{{ template.Code }}</td>
                    <td class="text-left">{{ template.Name }}</td>
                    <td class="text-left">{{ template.Subject }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('TemplateEmail', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenTemplate($event, template.Id, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('TemplateEmail', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              OpenTemplate($event, template.Id, false)
                            "
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('TemplateEmail', 'Delete')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              ConfirmDeleteTemplateEmail($event, index)
                            "
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      templates == undefined ||
                      templates == null ||
                      templates.length == 0
                    "
                  >
                    <td colspan="5">Sem registros</td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            placeholder="Código"
            type="text"
            class="form-control"
            v-model="filter.Code"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <input
            placeholder="Nome"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('TemplateEmail', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo template"
      v-on:click="NewTemplate()"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "template-emails",
  data: function () {
    return {
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      countFilter: 0,
      modalTitle: "Novo template",
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        Code: null,
        Name: null,
      },
      idTemplate: 0,
      pOpened: null,
      templates: [],
      infoTemplate: {
        Code: null,
        Name: null,
        Description: null,
        Subject: null,
        HTML: null,
        Tags: null,
      },
      isSeeing: false,
      validatedTemplateForm: false,
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListTemplateEmail();
    },
    "pagination.RowsPerPage": function () {
      this.ListTemplateEmail();
    },
  },
  mounted() {
    this.ListTemplateEmail();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListTemplateEmail();
    },
    OpenTemplate: function (e, id, view) {
      e.preventDefault();
      this.$router.push({
        name: "template-email",
        params: { idTemplateEmail: id },
        query: { isSeeing: view },
      });
    },
    NewTemplate: function (e) {
      this.$router.push({
        name: "template-email",
        params: { idTemplateEmail: 0 },
        query: { isSeeing: false },
      });
    },
    ResetInfoTemplate: function () {
      this.infoTemplate = {
        Code: null,
        Name: null,
        Description: null,
        Subject: null,
        HTML: null,
        Tags: null,
      };
    },
    ListTemplateEmail: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Code)) this.countFilter++;
      if (hasValue(this.filter.Name)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Name": this.filter.Name,
          "Object.Code": this.filter.Code,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListTemplateEmail", { params: data })
        .then((response) => {
          this.templates = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os templates",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ResetFilter: function () {
      this.filter = {
        Code: null,
        Name: null,
      };
      this.ListTemplateEmail();
    },
    ConfirmDeleteTemplateEmail: function (e, i) {
      e.preventDefault();
      let deleted = this.templates[i];
      this.$makeMsgBox(
        `Você tem certeza que deseja remover ${deleted.Name}?`,
        "Confirmar",
        this.DeleteTemplateEmail,
        i
      );
    },
    DeleteTemplateEmail: function (i) {
      let deleted = this.templates[i];
      this.$store
        .dispatch("DeleteTemplateEmail", { id: deleted.Id })
        .then(() => {
          this.$makeToast(
            `${deleted.Description} foi removido da sua lista de templates`,
            "success",
            "Template"
          );
          this.ListTemplateEmail();
          this.$bvModal.hide("mFormTemplate");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover o template",
            error
          );
        });
    },
  },
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/templateEmails.vue